import { Widget } from "blue-widgets";

class Selectable extends Widget {
  constructor(el) {
    super(el);
    this.init();
    this.children = [];
  }

  init() {
    const children = this.el.querySelectorAll("[selectable]");
    this.children = Array.from(children);
    this.children.forEach((child) => {
      child.addEventListener("click", (e) => this.selectChild(e), false);
    });
  }

  selectChild(e) {
    const selected = e.target;
    const current = this.el.querySelector(".isCurrent");
    if (current) {
      current.classList.remove("isCurrent");
    }
    selected.classList.add("isCurrent");
  }

  beforeRemove() {
    this.children.forEach((child) => {
      child.removeEventListener("click", (e) => this.selectChild(e), false);
    });
  }
}

export default Selectable;
